import React from 'react';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import { useTranslations } from 'use-intl';

interface PaymentSuccessStepProps {
  onComplete: () => void;
}

const PaymentSuccessStep: React.FC<PaymentSuccessStepProps> = ({ onComplete }) => {
  const t = useTranslations('consultantPayments.confirm.success');
  return (
    <div className="flex flex-col items-center justify-center py-12 space-y-6 text-center">
      <CheckCircle className="h-12 w-12 text-green-600 mx-auto mb-2" />
      <h3 className="text-lg font-semibold mb-2">{t('title')}</h3>
      <p className="text-sm text-muted-foreground mb-6 max-w-md mx-auto">{t('body')}</p>
      <Button onClick={onComplete} className="px-8 py-2 text-base font-semibold">{t('complete')}</Button>
    </div>
  );
};

export default PaymentSuccessStep; 